import { useAtom } from "jotai";
import { FC } from "react";
import { Select } from "../../../components/forms/select";
import { KycIcon } from "../../../components/icons/status";
import { StatusEnum } from "../../../store/users/models/internal";
import { selectedKycStatus } from "./atoms";

const allowedStatuses: Array<StatusEnum> = [
  "IN_REVIEW",
  "NOT_VERIFIED",
  "PENDING",
  "VERIFIED",
  "DELETED",
  "FAILED",
  "DECLINED",
];

export const KycStatusSelectorWrapper: FC<{}> = () => {
  const [selected, setSelected] = useAtom(selectedKycStatus);
  return (
    <Select
      fullWidth
      label="Select KYC Status"
      value={selected || "ALL"}
      onChange={(e: any) => {
        setSelected(e.target.value === "ALL" ? undefined : e.target.value);
      }}
      options={([...allowedStatuses, "ALL"] as Array<StatusEnum | "ALL">).map(
        (k) => ({
          title: k === "ALL" ? "All" : KycIcon(k, "kyc"),
          value: k,
        })
      )}
    />
  );
};
